import React from "react";

export const INVITE_ROLE_ORDER = ["admin", "member", "viewer"] as const;

type RoleDescriptionsLegendProps = {
  descriptions?: Record<string, string> | null;
};

export const RoleDescriptionsLegend: React.FC<RoleDescriptionsLegendProps> = ({
  descriptions,
}) => {
  if (!descriptions) return null;

  return (
    <ul className="mt-3 space-y-1.5 text-sm text-muted-foreground">
      {INVITE_ROLE_ORDER.map((role) => {
        const description = descriptions[role];
        if (!description) return null;
        return (
          <li key={role}>
            <span className="font-medium capitalize text-foreground">
              {role}
            </span>
            {": "}
            {description}
          </li>
        );
      })}
    </ul>
  );
};
